import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';

const DEFAULT_PCT = 15;

const SettingsContext = createContext({
  nightDiscountPct: DEFAULT_PCT,
  nightDiscountEnabled: true,
  nightDiscountLabel: `Stay Longer, Pay Less: ${DEFAULT_PCT}% OFF 2nd Night Onwards!`,
  refresh: () => {},
});

const API = process.env.REACT_APP_BACKEND_URL;

export const SettingsProvider = ({ children }) => {
  const [state, setState] = useState({
    nightDiscountPct: DEFAULT_PCT,
    nightDiscountEnabled: true,
    nightDiscountLabel: `Stay Longer, Pay Less: ${DEFAULT_PCT}% OFF 2nd Night Onwards!`,
  });

  const fetchSettings = useCallback(async () => {
    if (!API) return;
    try {
      const r = await fetch(`${API}/api/settings/public`);
      if (!r.ok) return;
      const d = await r.json();
      setState({
        nightDiscountPct: Number(d.night_discount_pct) || DEFAULT_PCT,
        nightDiscountEnabled: Boolean(d.night_discount_enabled),
        nightDiscountLabel: d.night_discount_label || `Stay Longer, Pay Less: ${d.night_discount_pct}% OFF 2nd Night Onwards!`,
      });
    } catch (_e) {
      // Silent fail — component will use DEFAULT_PCT and page still renders
    }
  }, []);

  useEffect(() => {
    fetchSettings();
    // Also poll every 5 minutes so admin edits show up on other open tabs
    const t = setInterval(fetchSettings, 5 * 60 * 1000);
    return () => clearInterval(t);
  }, [fetchSettings]);

  return (
    <SettingsContext.Provider value={{ ...state, refresh: fetchSettings }}>
      {children}
    </SettingsContext.Provider>
  );
};

export const useSettings = () => useContext(SettingsContext);
